<template>
    <div id="go-pos-dashboard">
        <div class="vx-breadcrumb mb-6">
            <ul class="flex flex-wrap items-center">
                <li class="inline-flex items-end">
                    <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
                    <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
                </li>
                <li class="inline-flex items-end">
                    <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Orders</span>
                </li>
            </ul>
        </div>
        <!-- <h4 class="font-bold text-2xl mb-base">Dashboard</h4> -->
        <vs-table :data="customersList.items" :max-items="itemsPerPage">
            <div slot="header" class="w-full">
                <div class="w-full flex-wrap flex align-center gap-5 justify-between my-header mb-6">
                  <div class="con-input-search vs-table--search ml-0 mr-3 dashboard-search">
                    <input type="text" class="input-search vs-table--search-input border-custom" placeholder="Search order" @keyup="handleSearch">
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                  </div>
                  <div class="flex flex-wrap gap-5 align-center ml-auto right-header">
                    <div class="flex-center">
                      <vs-button class="gradient gradient-primary no-shadow export-btn" @click="exportOrder">
                        <div class="flex-center">
                          <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
                          Export
                        </div>
                      </vs-button>
                      <div class="payment-filter">
                        <v-select @input="changePaymentFilter($event)" :value="payment_filter" label="title" :options="paymentOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                      </div>
                    </div>
                    <div class="btn-group">
                        <vs-button class="filter-btn all-btn" :class="{'active': active_status == 'all'}" @click="(active_status = 'all', changeStatus())">
                            All <br />{{ this.reportList.all }}
                        </vs-button>
                        <vs-button class="filter-btn processing-btn" :class="{'active': active_status == 'processing'}" @click="(active_status = 'processing', changeStatus())">
                            Processing <br />{{ this.reportList.processing }}
                        </vs-button>
                        <vs-button class="filter-btn done-btn" :class="{'active': active_status == 'done'}" @click="(active_status = 'done', changeStatus())">
                            Done <br />{{ this.reportList.done }}
                        </vs-button>
                        <vs-button class="filter-btn cancelled-btn" :class="{'active': active_status == 'cancelled'}" @click="(active_status = 'cancelled', changeStatus())">
                            Cancelled <br />{{ this.reportList.cancelled }}
                        </vs-button>
                        <vs-button class="filter-btn cancelled-btn" :class="{'active': active_status == 'settlement_failed'}" @click="(active_status = 'settlement_failed', changeStatus())">
                            Settlement Failed <br />{{ this.reportList.settlement_fail }}
                        </vs-button>
                    </div>
                    <div class="flex-center">
                        <date-picker class="created-date-picker" range :format="date_format_string" v-model="date_filter" range-separator="  to  " type="date" :editable="false" :clearable="false" placeholder="From date to date" @change="selectedDate"></date-picker>
                        <!-- <date-picker class="created-date-picker" :format="date_format_string" v-model="created_date" range-separator="  to  " type="date" :editable="false" :clearable="false" placeholder="Created date" @change="selectedDate"></date-picker> -->
                    </div>
                  </div>
                </div>
            </div>
            <template slot="thead">
                <vs-th class="flex-center" v-if="hasDeleteItem">
                  <vs-checkbox :value="isCheckAll" @click="checkAll"></vs-checkbox>
                </vs-th>
                <vs-th class="center-title text-center">ID</vs-th>
                <vs-th class="text-center">Customer</vs-th>
                <vs-th class="center-title text-center">Created At</vs-th>
                <vs-th class="center-title text-center">Payment</vs-th>
                <vs-th class="center-title text-center">Total</vs-th>
                <vs-th class="center-title text-center">Status</vs-th>
                <vs-th class="center-title text-center">
                  Delete
                  <div class="w-full translate-center" v-if="hasChecked">
                    <!-- <transition name="list"> -->
                      <vs-button
                        type="border"
                        color="danger"
                        class="text-base gradient gradient-danger no-shadow delete-btn"
                        @click="order_id_remove = null, popupActive = true"
                      >DELETE</vs-button>
                    <!-- </transition> -->
                  </div>
                </vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="shadow-md" :class="{'is-selected' : tr.delete_status}" @click.native="getOrderDetail(tr)">
                    <vs-td v-if="hasDeleteItem">
                      <vs-checkbox :value="tr.delete_status" @click.stop="changeDeleteStatus(indextr)" :key="tr.id" v-if="tr.pos_status != 'cancelled' && tr.pos_status != 'payment_success'"></vs-checkbox>
                      <!-- <vs-checkbox :value="tr.delete_status" @click.stop="changeDeleteStatus(indextr)" :key="tr.id" v-if="tr.pos_status != 'cancelled' && tr.pos_status != 'payment_success' && tr.pos_status != 'processing'"></vs-checkbox> -->
                      <vs-checkbox v-else class="visibility-hidden"></vs-checkbox>
                    </vs-td>
                    <vs-td class="text-center">
                      {{tr.id}}
                    </vs-td>
                    <vs-td class="break-word" style="min-width: 150px;" :data="data[indextr].customer_name">
                        <h5 class="font-bold">{{tr.customer_name}}</h5>
                        <p v-if="tr.phone" class="mt-2">
                            <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4 font-bold mr-1" />
                            <span>{{tr.phone}}</span>
                        </p>
                    </vs-td>
                    <vs-td class="text-center" :data="data[indextr].created_at">
                        <p class="text-center">{{ changeFormat(tr.created_at) }}</p>
                        <p class="text-center">{{ getTime(tr.created_at) }}</p>
                    </vs-td>
                    <!-- <vs-td class="text-center" v-if="tr.services != null" :data="data[indextr].services">{{ getServiceNum(tr.services) }}</vs-td>
                    <vs-td class="text-center" v-else :data="data[indextr].services">0</vs-td> -->
                    <vs-td class="text-center" style="min-width: 130px;" :data="data[indextr].order_payment_method">
                      <p v-html="getMultiplePaymentMethod(tr.multiple_payment.details)" v-if="tr.multiple_payment && tr.multiple_payment.details"></p>
                      <p v-html="getPaymentMethod(tr.order_payment_method, tr.external_credit_card)" v-else></p>
                    </vs-td>
                    <vs-td class="text-center font-bold color-black" v-if="tr.total_after_discount != null || tr.tip != null" :data="data[indextr].total_after_discount">${{ totalCheckin(tr.total_after_discount, tr.tip) }}</vs-td>
                    <vs-td class="text-center font-bold color-black" v-else :data="data[indextr].total_after_discount">$0</vs-td>
                    <vs-td class="text-center" :data="data[indextr].pos_status">
                        <vs-alert :color="getStatusColor(tr.pos_status)" class="flex align-center justify-center mx-auto" style="width: 150px; height: 40px !important">{{getNameStatus(tr.pos_status)}}</vs-alert>
                    </vs-td>
                    <vs-td class="text-center">
                        <span class="flex-center leading-none">
                            <!-- <vs-switch v-model="tr.switch_status" /> -->
                            <!-- <img src="../../assets/images/edit-icon.png" class="d-inline-block edit-icon" v-if="hasCash(tr.order_payment_method)" @click.stop="editOrder(tr)" /> -->
                            <img src="../../assets/images/trash-icon.png" class="d-inline-block trash-icon" @click.stop="deleteCheckin(tr)" v-if="tr.pos_status != 'cancelled' && tr.pos_status != 'payment_success'"/>
                            <!-- <img src="../../assets/images/trash-icon.png" class="d-inline-block trash-icon" @click.stop="cancelCheckin(tr)" v-else-if="tr.pos_status == 'payment_success' && hasCash(tr.order_payment_method)"/> -->
                            <!-- <img src="../../assets/images/trash-icon.png" class="d-inline-block trash-icon" @click.stop="deleteCheckin(tr)" v-if="tr.pos_status != 'cancelled'"/> -->
                            <img src="../../assets/images/trash-icon.png" class="d-inline-block trash-icon visibility-hidden" v-else/>
                        </span>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-popup class="holamundo delete-staff-popup" title="Delete Order" :active.sync="popupActive">
            <div class="text-center">
              <h3 v-if="order_id_remove != null">Do you want to delete this order?</h3>
              <h3 v-else>Do you want to delete these orders?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
              <!-- <vs-button class="mr-6 align-center delete-responsive" @click="deleteCheckinItem">Delete</vs-button> -->
              <!-- <vs-button class="mr-6 align-center delete-responsive" @click="deleteOrder">Delete</vs-button> -->
              <vs-button class="mr-6 align-center delete-responsive" @click="deleteOrders">Delete</vs-button>
              <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupActive = false">Cancel</vs-button>
              </div>
          </div>
        </vs-popup>
        <vs-popup class="holamundo delete-staff-popup" title="Cancel Order" :active.sync="popupCancelActive">
            <div class="text-center">
              <h3>Do you want to cancel this order?</h3>
              <div class="flex flex-wrap justify-center align-center p-6 mt-6">
              <vs-button class="mr-6 align-center delete-responsive" @click="cancelOrder">Ok</vs-button>
              <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="popupCancelActive = false">Cancel</vs-button>
              </div>
          </div>
        </vs-popup>
        <div v-if="customersList._meta && customersList._meta.pageCount">
        <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(customersList._meta.pageCount)"
            :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
        </div>
        <vs-popup-order-detail :popupOrderDetail="popupOrderDetail" :active_id="active_id" :key="detail_key" @ClosePopup="closePopup" @GoToOrder="goToOrder"></vs-popup-order-detail>
        <update-order-popup :editOrderPopup="editOrderPopup" :order_id="active_id" @UpdateComplete="updateComplete"></update-order-popup>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import vSelect from 'vue-select';
import { changeFormatHelper, formatDateString, formatExportDateString } from '../../helper/datetimeHelper';
import moment from 'moment';
import FileDownload from'js-file-download';
export default {
    components: { DatePicker, vSelect },
    data() {
        let date_format_string = formatDateString();
        let format_export_date_string = formatExportDateString();
        return {
            created_date: new Date(),
            // date_filter: [new Date((new Date()).getFullYear(), (new Date()).getMonth(), 1), new Date()],
            date_filter: [new Date(), new Date()],
            date_format_string,
            format_export_date_string,
            itemsPerPage: 20,
            active_status: 'all',
            active_id: 0,
            currentPage: 1,
            page_key: 0,
            checkinList: {},
            // customersList: {},
            pageCount: 0,
            popupActive: false,
            popupCancelActive: false,
            order_id_remove: null,
            order_status_remove: "",
            popupOrderDetail: {
              isOpen : false
            },
            detail_key: 0,
            isOpenLoading: false,
            paymentOptions: [
              { type: 0, title: 'All' },
              { type: 1, title: 'Credit Card' },
              { type: 2, title: 'Cash' },
              { type: 3, title: 'Gift Card' },
              { type: 4, title: 'Check' },
              { type: 5, title: 'ACH' }
            ],
            payment_filter: { type: 0, title: 'All' },
            action_type: 'Get data',
            editOrderPopup: { isOpen: false },
            keyword: ""
        }
    },
    methods: {
        goToOrder(item){
          this.popupOrderDetail.isOpen = true;
          this.active_id = item.id
          this.detail_key++;
        },
        closePopup(){
          this.popupOrderDetail.isOpen = false;
        },
        getOrderDetail(tr){
          this.popupOrderDetail.isOpen = true;
          this.active_id = tr.id
          this.detail_key++;
        },
        editOrder(tr) {
          this.openLoadingInDiv();
          this.action_type = "Get data";
          this.$store.dispatch("goPos/GET_ORDER_DETAIL", { id: tr.id }).then(() => {
            this.closeLoading();
            this.editOrderPopup.isOpen = true;
          })
        },
        async updateComplete(order_id) {
          this.editOrderPopup.isOpen = false;
          await this.selectedDate();
          this.active_id = order_id;
          this.popupOrderDetail.isOpen = true;
          this.detail_key++;
        },
        deleteCheckin(tr){
          this.popupActive = true;
          this.order_id_remove = tr.id;
          this.order_status_remove = tr.pos_status;
        },
        cancelCheckin(tr) {
          this.popupCancelActive = true;
          this.order_id_remove = tr.id;
          this.order_status_remove = tr.pos_status;
        },
        // deleteCheckinItem(){
        //   this.openLoadingInDiv();
        //   const obj = {
        //     order_id: this.order_id_remove,
        //     status: 'cancelled',
        //     page: this.currentPage,
        //     "per-page": this.itemsPerPage,
        //     type: this.active_status,
        //     // date: this.formatDate(this.created_date)
        //     from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
        //     to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
        //     payment_type: this.payment_filter.type
        //   }
        //   this.action_type = "Remove checkin";
        //   this.$store.dispatch("goPos/REMOVE_CHECKIN_ITEM", obj).then(() => {
        //     this.popupActive = false;
        //     this.closeLoading();
        //   })
        // },
        // deleteOrder() {
        //   this.openLoadingInDiv();
        //   let obj = {
        //     order_id: this.order_id_remove,
        //     page: this.currentPage,
        //     "per-page": this.itemsPerPage,
        //     type: this.active_status,
        //     // date: this.formatDate(this.created_date)
        //     from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
        //     to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
        //     payment_type: this.payment_filter.type
        //   }
        //   this.popupActive = false;
        //   this.action_type = "Remove order";
        //   this.$store.dispatch("goPos/REMOVE_ORDER", obj).then(() => {
        //     this.closeLoading();
        //     this.$vs.notify({
        //       title:'Notification',
        //       text:'Remove order success',
        //       color:'success',
        //       position:'top-right'});
        //   })
        // },
        deleteOrders() {
          // this.order_id_remove = null;
          let order_ids = [];
          if(this.order_id_remove != null) {
            order_ids.push(this.order_id_remove);
          } else {
            if(this.customersList.items && this.customersList.items.length > 0) {
              for(let i = 0; i < this.customersList.items.length; i++) {
                if(this.customersList.items[i].delete_status) {
                  order_ids.push(this.customersList.items[i].id);
                }
              }
            }
          }
          this.openLoadingInDiv();
          let obj = {
            order_id: order_ids,
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            type: this.active_status,
            // date: this.formatDate(this.created_date)
            from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
            to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
            payment_type: this.payment_filter.type,
            keyword: this.keyword
          }
          this.popupActive = false;
          this.action_type = "Remove order";
          this.$store.dispatch("goPos/REMOVE_ORDER", obj).then(() => {
            this.closeLoading();
            this.$vs.notify({
              title:'Notification',
              text:'Remove order success',
              color:'success',
              position:'top-right'});
          })
        },
        cancelOrder() {
          let obj = {
            order_id: this.order_id_remove,
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            type: this.active_status,
            from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
            to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
            payment_type: this.payment_filter.type,
            keyword: this.keyword
          }
          this.openLoadingInDiv();
          this.popupCancelActive = false;
          this.action_type = "Cancel order";
          this.$store.dispatch("goPos/CANCEL_ORDER", obj).then(() => {
            this.closeLoading();
            this.$vs.notify({
              title:'Notification',
              text:'Cancel order success',
              color:'success',
              position:'top-right'});
          })
        },
        checkAll() {
          // console.log(this.isCheckAll);
          this.$store.commit("goPos/CHANGE_ALL_DELETE_STATUS", !this.isCheckAll);
        },
        changeDeleteStatus(index) {
          this.$store.commit("goPos/CHANGE_DELETE_STATUS", index);
          // console.log(item);
        },
        exportOrder() {
          this.openLoadingInDiv();
          let obj = {
            // page: this.currentPage,
            // "per-page": this.itemsPerPage,
            type: this.active_status,
            // date: this.formatDate(this.created_date)
            from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
            to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
            payment_type: this.payment_filter.type,
            export: 1,
            keyword: this.keyword
          }
          this.popupActive = false;
          this.action_type = "Export order";
          this.$store.dispatch("goPos/EXPORT_ORDER", obj).then((res) => {
            FileDownload(res.data, `export-orders-${moment().format(this.format_export_date_string)}.xls`);
            this.closeLoading();
            this.$vs.notify({
              title:'Notification',
              text:'Export order success',
              color:'success',
              position:'top-right'});
          })
        },
        openLoadingInDiv(){
          this.$vs.loading({
            container: '#app',
            scale: 0.8
          })
          if(this.loadTime){
              clearTimeout(this.loadTime);
              this.loadTime = null;
          }
          this.isOpenLoading = true;
          this.loadTime = setTimeout( ()=> {
              if(this.isOpenLoading) {
                  this.closeLoading();
                  this.$vs.dialog({
                      color: 'danger',
                      title: 'Notification',
                      text: this.action_type + ' failed',
                      acceptText: 'OK'
                  })
              }
          }, 10000);
        },
        closeLoading() {
          this.$vs.loading.close('#app > .con-vs-loading');
          this.isOpenLoading = false;
        },
        changePage(currentPage) {
          this.openLoadingInDiv();
          const obj = {
              page: currentPage,
              "per-page": this.itemsPerPage,
              type: this.active_status,
              // date: this.formatDate(this.created_date)
              from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
              to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
              payment_type: this.payment_filter.type,
              keyword: this.keyword
          }
          this.action_type = "Get data";
          this.$store.dispatch("goPos/GET_LIST_CHECKIN", obj).then(() => {
            this.closeLoading();
            this.currentPage = currentPage;
            this.page_key++;
          })
        },
        changeFormat(date) {
          if(date) {
            return changeFormatHelper(date);
          } else {
            return 'N/A';
          }
        },
        getTime(date) {
          if(date) {
            return moment(date).format('hh:mm A');
          } else {
            return '';
          }
        },
        getStatusColor(status) {
            if(status == 'processing') {
                return '#FF9F43'
            } else if (status == 'pending') {
                return '#438D00'
            } else if (status == 'cancelled') {
                return '#E20E0E'
            } else if (status == 'refunded') {
                return '#FBBA17'
            } else if (status == 'voided') {
                return '#ED6EF2'
            } else if (status == 'payment_success') {
                return '#5B94E2'
            } else if (status == 'transaction_settled') {
                return '#844CEF'
            } else if (status == 'settlement_failed') {
                return '#E20E0E'
            } else if (status == 'awaiting_payment') {
                return '#438D00'
            }
        },
        getNameStatus(status) {
          if(status == 'cancelled'){
            return 'Cancelled'
          } else if(status == 'pending'){
            return 'Pending'
          } else if(status == 'processing'){
            return 'Processing'
          } else if (status == 'refunded') {
            return 'Refunded'
          } else if (status == 'voided') {
              return 'Voided'
          } else if (status == 'payment_success') {
              return 'Payment Success'
          } else if (status == 'transaction_settled') {
              return 'Settled'
          } else if (status == 'settlement_failed') {
              return 'Settlement Failed'
          } else if (status == 'awaiting_payment') {
              return 'Awaiting Payment'
          }
        },
        hasCash(payment_method) {
          if(payment_method && payment_method.length > 0) {
            // for(let i = 0; i < payment_method.length; i++) {
            //   if(payment_method[i].payment_method_type == 2) {
            //     return true;
            //   }
            // }
            if(payment_method.length == 1 && payment_method[0].payment_method_type == 2) {
              return true;
            }
          }
          return false;
        },
        getPaymentMethod(payment_method, external_credit_card = 0) {
          let externalExist = false;
          if(payment_method.some((payment) => payment.payment_method_type == 6)) {
            externalExist = true;
          }
          let arr = [];
          if(payment_method && payment_method.length > 0) {
            for(let i = 0; i < payment_method.length; i++) {
              switch(payment_method[i].payment_method_type) {
                case 1: {
                  if(external_credit_card == 1 && !externalExist) {
                    arr.push("External Credit");
                  } else {
                    arr.push("Credit Card"); 
                  }
                  continue;
                }
                case 2: arr.push("Cash"); continue;
                case 3: arr.push("Gift Card"); continue;
                case 4: arr.push("Check"); continue;
                case 5: arr.push("ACH"); continue;
                case 6: arr.push("External Credit"); continue;
                default: continue;
              }
            }
          }
          return arr && arr.length > 0 ? arr.join('<br />') : 'N/A';
        },
        getMultiplePaymentMethod(payment_method) {
          let arr = [];
          let titleArr = [];
          if(payment_method && payment_method.length > 0) {
            for(let i = 0; i < payment_method.length; i++) {
              if(!arr.includes(payment_method[i].type)) {
                arr.push(payment_method[i].type);
                switch(payment_method[i].type) {
                  case "credit": titleArr.push("Credit Card"); continue;
                  case "cash": titleArr.push("Cash"); continue;
                  case "gift_card": titleArr.push("Gift Card"); continue;
                  case "check": titleArr.push("Check"); continue;
                  case "app": titleArr.push("External Credit"); continue;
                  default: continue;
                }
              }
            }
          }
          return titleArr && titleArr.length > 0 ? titleArr.join('<br />') : 'N/A';
        },
        totalCheckin(total, tip){
          // return Math.round( number * 100 + Number.EPSILON ) / 100;
          let result = 0;
          if(total != null) {
            result = total;
          }

          if(tip != null) {
            result += tip.total_tip;
          }

          return Math.round( result * 100 + Number.EPSILON ) / 100;
        },
        async changeStatus(){
          this.currentPage = 1;
          const obj = {
            type: this.active_status,
            // date: this.formatDate(this.created_date)
            from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
            to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
            payment_type: this.payment_filter.type,
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            keyword: this.keyword
          }
          if(!this.isOpenLoading) {
            this.openLoadingInDiv();
          }
          this.action_type = "Get data";
          await this.$store.dispatch("goPos/GET_LIST_CHECKIN", obj)
          await this.$store.dispatch("goPos/GET_REPORT_CHECKIN", obj)

          this.closeLoading();
        },
        async changePaymentFilter(e) {
          this.payment_filter = JSON.parse(JSON.stringify(e));
          this.changeStatus();
        },
        formatDate(day){
          let countryCode = localStorage.getItem('country_code');
          if (countryCode == "AU") {
            return moment(day).format('DD/MM/YYYY');
          } else if (countryCode == "US") {
            return moment(day).format('MM/DD/YYYY');
          } else {
            return moment(day).format('MM/DD/YYYY');
          }
        },
        async selectedDate(){
          this.currentPage = 1;
          const obj = {
            type: this.active_status,
            // date: this.formatDate(this.created_date)
            from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
            to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
            payment_type: this.payment_filter.type,
            page: this.currentPage,
            "per-page": this.itemsPerPage,
            keyword: this.keyword
          }
          if(!this.isOpenLoading) {
            this.openLoadingInDiv();
          }
          this.action_type = "Get data";
          await this.$store.dispatch("goPos/GET_LIST_CHECKIN", obj)
          await this.$store.dispatch("goPos/GET_REPORT_CHECKIN", obj)

          this.closeLoading();
        },
        getServiceNum(data) {
          if(data && data.length) {
            let number = 0;
            for(let i = 0; i < data.length; i++) {
              let service = data[i];
              if(service && service.items && service.items.length > 0) {
                number += service.items.length;
              }
            }
            return number;
          }
          return 0;
        },
        handleSearch({ target }) {
          if (this.timer) {
            clearTimeout(this.timer);
            this.timer = null;
          }
          if (!this.isOpenLoading) {
            this.openLoadingInDiv();
          }

          this.timer = setTimeout(() => {
            this.keyword = target.value;
            const obj = {
              page: this.currentPage,
              "per-page": this.itemsPerPage,
              type: this.active_status,
              // date: this.formatDate(this.created_date)
              from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
              to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
              payment_type: this.payment_filter.type,
              keyword: this.keyword
            }
            this.action_type = "Get data";
            this.$store.dispatch("goPos/GET_LIST_CHECKIN", obj).then(() => {
              this.closeLoading();
            });
          }, 500);
        }
    },
    computed: {
        customersList(){
          return this.$store.state.goPos.customerList;
        },
        reportList(){
          return this.$store.state.goPos.reportList;
        },
        isCheckAll() {
          return this.$store.getters["goPos/isCheckAll"];
        },
        hasChecked() {
          return this.$store.getters["goPos/hasChecked"];
        },
        hasDeleteItem() {
          return this.$store.getters["goPos/hasDeleteItem"];
        }
    },
    async created(){
      const obj = {
        // date: this.formatDate(new Date())
        from: moment(this.date_filter[0]).format("YYYY-MM-DD"),
        to: moment(this.date_filter[1]).format("YYYY-MM-DD"),
        payment_type: this.payment_filter.type,
        page: this.currentPage,
        "per-page": this.itemsPerPage
      }
      if(!this.isOpenLoading) {
        this.openLoadingInDiv();
      }
      await this.$store.dispatch("goPos/GET_LIST_CHECKIN", obj)
      await this.$store.dispatch("goPos/GET_REPORT_CHECKIN", obj)
      await this.$store.dispatch("staffList/GET_STAFF_LIST", { page: 1, 'per-page': 100 });

      this.closeLoading();
    }
}
</script>
